module.exports = __webpack_public_path__ + "img/emptyGroup.fad7f944.svg";